import styles from './ServerErrorPage.module.scss';

import { useApiInterceptor } from '@/app/providers/ApiInterceptorContext';
import error505 from '@/assets/img/error505.jpg';
import { Button } from '@/shared/ui-kit/Button/Button';
import { Modal } from '@/shared/ui-kit/Modal/Modal';

export const ServerErrorPage: React.FC = () => {
  const { serverError500 } = useApiInterceptor();

  const reload = () => {
    window.location.reload();
  };

  return (
    <Modal hideHeader closable={false} open={serverError500} onClose={reload}>
      <div className={styles.container}>
        <h2 className={styles.title}>Технические работы</h2>
        <div className={styles.imageContainer}>
          <img src={error505} alt="" />
          <div className={styles.textContainer}>
            <p className={styles.text}>Уже решаем проблему</p>
            <p className={styles.textSub}>
              Попробуйте обновить страницу через пару минут
            </p>
          </div>
        </div>
        <Button className={styles.button} onClick={reload}>
          Обновить
        </Button>
      </div>
    </Modal>
  );
};
